import { render, staticRenderFns } from "./MetamaskCustomTokenForm.vue?vue&type=template&id=2f1dfeef&"
import script from "./MetamaskCustomTokenForm.vue?vue&type=script&lang=js&"
export * from "./MetamaskCustomTokenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports